(function () {
    window._ = require('lodash');

    /**
     * We'll load jQuery and the Bootstrap jQuery plugin which provides support
     * for JavaScript based Bootstrap features such as modals and tabs. This
     * code may be modified to fit the specific needs of your application.
     */

    try {
        window.Popper = require('popper.js').default;
        window.$ = window.jQuery = require('jquery');

        window.moment = require('moment');

        require("bootstrap");
        require("jquery-ui/ui/widgets/datepicker");
        require("jquery-ui/ui/widgets/sortable");
        window.autosize = require('autosize')
    } catch (e) {
        console.log(e)
    }

    window.Cropper = require('cropperjs');

    /**
     * Next we will load all of this project's JavaScript dependencies.
     * It is a great starting point when building robust, powerful web applications.
     */

    $(document).ready(function () {
        /**
         * Ajax CSRF TOKEN Header
         */
        $.ajaxSetup({
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')}
        });


        /**
         * Datepicker Jquery UI
         */
        $('.datepicker').datepicker({
            dateFormat: 'dd-mm-yy',
            firstDay: 1,
            beforeShow: function (input, datepicker) {
                var datepickerTop = $(input).offset().top + parseInt($(input).outerHeight()) - $(document).scrollTop();
                setTimeout(function () {
                    datepicker.dpDiv.css({
                        top: datepickerTop
                    });
                }, 0);
            }
        });

        /**
         * Auto select end dates on select of start date.
         */
        $('.datepicker[name*=start]').on('change', function (e) {
            var endTime = $(this).parent().parent().parent().find('.datepicker[name*=end]');

            if (endTime.val() === "") {
                endTime.val($(this).val());
            }

            setTimeout(() => {
                if ($(this).hasClass('open-end-datepicker')) {
                    let endAfterDate = new Date($(this).datepicker('getDate'));
                    endAfterDate.setDate(endAfterDate.getDate() + 1)

                    endTime.datepicker("option", "minDate", endAfterDate).datepicker("show");
                }
            }, 150)
        });

        /**
         * Auto select end dates on select of start date.
         */
        $('.datepicker[name*=end]').on('change', function (e) {
            var startTime = $(this).parent().parent().parent().find('.datepicker[name*=start]');

            if (startTime.val() === "") {
                startTime.val($(this).val());
            }
        });

        /**
         * Update value with group btn (used in tables)
         */
        $(".btn-group.ajax-update > .btn").click(function () {
            var clicked = $(this);
            clicked.addClass("active").siblings().removeClass("active");

            $.ajax({
                method: "PUT",
                url: clicked.parent().attr('data-update-url'),
                data: {'type': clicked.attr('data-name')}
            });
        });

        /**
         * Show file name(s) after selecting using a custom file input field
         */
        $('.custom-file-input').on('change', function (event) {
            var files = [];

            $.each(event.target.files, function (index, value) {
                files.push(value.name)
            });

            $(this).next('.custom-file-label').addClass("selected").html(files.join(', '));
        });

        /**
         * Copy multiple presets (Vacations and Holidays)
         */
        $('.copy-multiple').on('submit', function () {
            try {
                var inputName = $(this).attr('data-input-name');

                var ids = $('input[name="' + inputName + '[]"]').serializeArray();

                ids = $.map(ids, function (item) {
                    return item.value;
                });

                $(this).find('input[name="ids"]').val(ids.join(','));
            } catch (e) {
                return false;
            }

            return true;
        });

        /**
         * Cropper js
         */
        var $container = $('.cropperjs-container');
        var $image = $container.find('img');
        if ($image.length > 0) {
            new Cropper(document.getElementById($image.attr('id')), {
                aspectRatio: parseFloat($image.attr('data-aspect-ratio')),
                viewMode: 1,
                data: {
                    x: parseInt($image.attr('data-cropbox_x')),
                    y: parseInt($image.attr('data-cropbox_y')),
                    width: parseInt($image.attr('data-cropbox_width')),
                    height: parseInt($image.attr('data-cropbox_height')),
                    rotate: 0,
                    scaleX: 1,
                    scaleY: 1
                },
                crop: function (e) {
                    e = e.detail;
                    $container.find('input[name=cropped_x]').val(e.x);
                    $container.find('input[name=cropped_y]').val(e.y);
                    $container.find('input[name=cropped_width]').val(e.width);
                    $container.find('input[name=cropped_height]').val(e.height);
                }
            });
        }

        if ($('.chat-container').length || $('#chat-overview-container').length) {
            require('../../shared/js/chat');
        }

        if ($('#review-container').length) {
            require('./review');
        }

        $('.custom-file-input').change((e) => {
            let text = '';

            for (let k in e.target.files) {
                if (e.target.files.hasOwnProperty(k)) {
                    if (text.length === 0)
                        text = e.target.files[k].name
                    else
                        text = text + ', ' + e.target.files[k].name
                }
            }

            if (text.length === 0)
                $(e.target).siblings('label').text('Choose file')
            else {
                $(e.target).siblings('label').text(text)
            }
        });

        jQuery.fn.getFormDataAssociative = function () {
            let fd = new FormData();
            let f = this.serializeArray();
            for (let k in f) {
                if (f.hasOwnProperty(k)) {
                    fd.append(f[k].name, f[k].value);
                }
            }

            this.find('input[type="file"]').each((k, v) => {
                for (let fk in v.files) {
                    if (v.files.hasOwnProperty(fk))
                        fd.append($(v).attr('name'), v.files[fk] ?? '');
                }
            });

            return fd;
        }

        jQuery.fn.fillFormErrors = function (err) {
            let f = $(this[0]);
            for (let k in err) {
                if (err.hasOwnProperty(k)) {
                    f.find('[name="' + k + '"]').addClass('is-invalid')
                        .closest('.form-group')
                        .find('.invalid-feedback')
                        .addClass('d-block')
                        .text(err[k]);
                }
            }
        }

        $(document).on('click', '.disable-after-click', function (e) {
            $(this).html($(this).text() + '<div class="spinner-border spinner-border-sm" role="status"><span class="sr-only">Loading...</span></div>')
            setTimeout(() => {
                $(this).prop('disabled', true);
                $(this).css('cursor', 'unset');
            });
        });
    });


// function to detect if an element is visible on screen.
    $.fn.isInViewport = function () {
        var elementTop = $(this).offset().top;
        var elementBottom = elementTop + $(this).outerHeight();

        var viewportTop = $(window).scrollTop();

        var viewportBottom = viewportTop + $(window).height();

        return elementBottom > viewportTop && elementTop < viewportBottom;
    };


})();

require('./components/gtm');
require('./components/back-button');
require('./tools/sha-256-hash')
require('../../admin/js/tools/prevent-double-click');
require('../../shared/js/hide-tooltips')
require('../../shared/js/uppercase-replace-spaces')
require('./components/vouchers');


$(function () {
    $('[data-toggle="tooltip"]').tooltip()
    $('[data-tooltip]').tooltip()
})

